module.exports = __webpack_public_path__ + "img/9-filters-02.6258069b.svg";